module.exports = __webpack_public_path__ + "img/logos-Vue-React-jQuery.aeea7628.png";